import { render } from "./ExperienceComponent.vue?vue&type=template&id=aa49bfcc&scoped=true"
import script from "./ExperienceComponent.vue?vue&type=script&lang=js"
export * from "./ExperienceComponent.vue?vue&type=script&lang=js"

import "./ExperienceComponent.vue?vue&type=style&index=0&id=aa49bfcc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa49bfcc"]])

export default __exports__